module.exports = __webpack_public_path__ + "img/icb-leo-Inte-m@2x.d2754709.png";